/* global angular, Modernizr, $ */
angular.module('ua5App')
    .directive('siteHeader', ['$rootScope', function($rootScope) {
        return {
            templateUrl: 'components/site_header/site_header.html',
            restrict: 'E',
            scope: {},
            link: function($scope, $element, $attrs) {
                //-- if not mobile
                if (!(Modernizr.touch && $(window).width() <= 767)) {
                    $element.children().addClass('site-header__hide');
                    $rootScope.$on('logoAnimationComplete', function() {
                        $element.children().removeClass('site-header__hide');
                    });
                }
            }
        };
    }])
;
